import Bell from '../icons/Bell';
import Close from '../icons/Close';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { languageContent } from '../../@helpers';
import './style.scss';


@inject('CookieStore')
@observer
class CookieNotification extends Component {

  componentDidMount() {
    const { CookieStore: { populate } } = this.props
    populate();
  }

  render() {
    const { CookieStore: { viewed, closeCookieNotification } } = this.props
    const content = languageContent();
    const { component } = content;

    const { pTagTop, pTagBottom, anchorText } = component.CookieNotification;
    return (
      <dialog
        data-active={!viewed}
        ref={(ref) => this.props.CookieStore.contentAnchor = ref}
        className="cookie_notification grid-columns-full"
      >
        <div>
          <span className="icon_wrapper"><Bell /></span>
          <p>
            {pTagTop}.
            {' '}
            {/* <strong>{pTagBottom} <a href="/privacy-policy" target="_blank" rel="nofollow noopener noreferrer">{anchorText}</a></strong> */}
            <strong>{pTagBottom} <a href="/privacy-policy" target="_blank" rel="nofollow noopener noreferrer">{anchorText}</a></strong>
          </p>
        </div>
        <button className="button button-icon" onClick={closeCookieNotification}><Close /></button>
      </dialog>
    )
  }
}

export default CookieNotification
